/**
 * Add page/section specific features here.
 *
 * To load a feature on more than one page,
 * separate each class name with a comma and a space
 * @type {Object}
 */

var Pages = {
	'.pt_azdesigners': {
		init: function(){
			require.ensure([], function () { require('../pages/designers'); }, 'designers');
		}
	},

	'.pt_product-details': {
		init: function(){
			require.ensure([], function () { require('../pages/pdp').init(); }, 'pdp');
		}
	},

	'.pt_product-search-result': {
		init: function() {
			require.ensure([], function() { require('../pages/plp').init(); }, 'plp');
		}
	},

	'.pt_blog': {
		init: function(){
			require.ensure([], function () { require('../pages/blog').init(); }, 'blog');
		}
	},

	'.pt_checkout': {
		init: function(){
			require.ensure([], function () { require('../pages/checkout-common').init(); }, 'checkout');
		}
	}
};

export default Pages;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/helpers/pages.js